import React, { useEffect } from "react";
import { Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsArrowClockwise } from "react-icons/bs";
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";

const FREIGHT_IMP_PM_KPI = ({data, changeValues, filter, showModalCalRange}) => {

    const { setValues, values, calculoPromedio, calculoYesNo, calculoPeriod, calculoPerType, calculoPerTypeStatus, calculoFundingSources } = useKPIs();

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {
       
        const datas = {
            project_type: {
                infrastructure: calculoPerType('type_foreseen_interven', 'infrastructure', filter.yearInit),
                reconstruction: calculoPerType('type_foreseen_interven', 'reconstruction', filter.yearInit),
                maintenances: calculoPerType('type_foreseen_interven', 'maintenances', filter.yearInit),
                horizontal: calculoPerType('type_foreseen_interven', 'horizontal', filter.yearInit)
            },
            TEN_TCompliance: { 
                inter_modality: {
                    bef_inter_modality: calculoYesNo('bef_inter_modality', filter.yearInit),
                    aft_inter_modality: calculoYesNo('aft_inter_modality', filter.yearInit)
                },
                train_length_740m: {
                    bef_train_length_740m: calculoYesNo('bef_train_length_740m', filter.yearInit),
                    aft_train_length_740m: calculoYesNo('aft_train_length_740m', filter.yearInit)
                },
                electrification: {
                    bef_electrification: calculoYesNo('bef_electrification', filter.yearInit),
                    aft_electrification: calculoYesNo('aft_electrification', filter.yearInit)
                }, 
                open_avail: {
                    bef_open_avail: calculoYesNo('bef_open_avail', filter.yearInit),
                    aft_open_avail: calculoYesNo('aft_open_avail', filter.yearInit)
                },
            },
            project_status: {
                status_high_level: {
                    implemented: calculoPerTypeStatus('implemented', filter.yearInit),
                    ongoing_proj_fs: calculoPerTypeStatus('ongoing_proj_fs', filter.yearInit),
                    mature_proj_fs: calculoPerTypeStatus('mature_proj_fs', filter.yearInit),
                    proj_under_prep: calculoPerTypeStatus('proj_under_prep', filter.yearInit)
                }, 
                status_detailed: {
                    implemented: calculoPerTypeStatus('implemented', filter.yearInit),
                    ongoing_proj_fs: {
                        workCur: calculoPerType('ongoing_proj_fs', 'workCur', filter.yearInit),
                        tenderWork: calculoPerType('ongoing_proj_fs', 'tenderWork', filter.yearInit),
                        designTender: calculoPerType('ongoing_proj_fs', 'designTender', filter.yearInit),
                        tenderOngoing: calculoPerType('ongoing_proj_fs', 'tenderOngoing', filter.yearInit)
                    },
                    mature_proj_fs: {
                        finOngoing: calculoPerType('mature_proj_fs', 'finOngoing', filter.yearInit),
                        finProceduresNotyetStarted: calculoPerType('mature_proj_fs', 'finProceduresNotyetStarted', filter.yearInit),
                        finSourceNotInd: calculoPerType('mature_proj_fs', 'finSourceNotInd', filter.yearInit)
                    },
                    proj_under_prep: {
                        feasOnGoing: calculoPerType('proj_under_prep', 'feasOnGoing', filter.yearInit),
                        feasUnderTen: calculoPerType('proj_under_prep', 'feasUnderTen', filter.yearInit),
                        financing: calculoPerType('proj_under_prep', 'financing', filter.yearInit)
                    }
                }
            },
            project_funding: {
                funding_source: {
                    proj_fund_nat_budg: calculoFundingSources('proj_fund_nat_budg', filter.yearInit),
                    proj_fund_wb: calculoFundingSources('proj_fund_wb', filter.yearInit),
                    proj_fund_ebrd: calculoFundingSources('proj_fund_ebrd', filter.yearInit),
                    proj_fund_eib: calculoFundingSources('proj_fund_eib', filter.yearInit),
                    other_ifi: calculoFundingSources('other_ifi', filter.yearInit),
                    concessions: calculoFundingSources('concessions', filter.yearInit),
                    eu_fund: calculoFundingSources('eu_fund', filter.yearInit),
                    other_fund: calculoFundingSources('other_fund', filter.yearInit)
                },
                capex: "" // TODO: CONSULTAR CAMPO
            },
            performance_indicators: {
                const_period: calculoPeriod('actual_const_period', 'forecast_const_period', filter.yearInit),
                capex: calculoPeriod('actual_capex', 'forecast_capex', filter.yearInit),
                opex: calculoPeriod('actual_opex', 'forecast_opex', filter.yearInit),
                maint_cost: calculoPeriod('actual_maint_cost', 'forecast_maint_cost', filter.yearInit),
                interest_during_const: calculoPromedio('interest_during_const', filter.yearInit),
                ebitda: "",
                revenue: calculoPeriod('actual_revenue', 'forecast_revenue', filter.yearInit),
                traffic_dev: {
                    train_traffic: calculoPeriod('actual_terminal_traffic', 'forecast_terminal_traffic', filter.yearInit),
                    pass_traffic: calculoPeriod('actual_pass_traffic', 'forecast_pass_traffic', filter.yearInit),
                    freight_tn: calculoPeriod('actual_freight_tn', 'forecast_freight_tn', filter.yearInit)
                }
            }
        }

        changeValues(datas)
    }

    return (
        <Tabs defaultActiveKey="project_type" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
             <Tab eventKey="project_type" title="Project Type" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.infrastructure" label="New infrastructure" name="project_type.infrastructure" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.reconstruction" label="Reconstruction/rehabilitation" name="project_type.reconstruction" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.maintenances" label="Maintenance" name="project_type.maintenances" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.horizontal" label="Horizontal/policy measure" name="project_type.horizontal" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="TEN_TCompliance" title="TEN-T Compliance" className={style.tabHeight} style={{height: "66vh"}}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.inter_modality.bef_inter_modality" label="Inter-modality (before)" name="TEN_TCompliance.inter_modality.bef_inter_modality" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.inter_modality.aft_inter_modality" label="Inter-modality (after)" name="TEN_TCompliance.inter_modality.aft_inter_modality" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.train_length_740m.bef_train_length_740m" label="740m train length (before)" name="TEN_TCompliance.train_length_740m.bef_train_length_740m" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.train_length_740m.aft_train_length_740m" label="740m train length (after)" name="TEN_TCompliance.train_length_740m.aft_train_length_740m" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.electrification.bef_electrification" label="Electrified access (before)" name="TEN_TCompliance.electrification.bef_electrification" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.electrification.aft_electrification" label="Electrified access (after)" name="TEN_TCompliance.electrification.aft_electrification" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.open_avail.bef_open_avail" label="Open availability (before)" name="TEN_TCompliance.open_avail.bef_open_avail" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.open_avail.aft_open_avail" label="Open availability (after)" name="TEN_TCompliance.open_avail.aft_open_avail" disabled={true}/>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_status" title="Project Status" className={style.tabHeight} style={{height: "66vh"}}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Status (high level)</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.implemented" label="% Implemented" name="project_status.status_high_level.implemented" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.ongoing_proj_fs" label="% On-going project (funding secured)" name="project_status.status_high_level.ongoing_proj_fs" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.mature_proj_fs" label="% Mature project (feasibility study ready, funding secured)" name="project_status.status_high_level.mature_proj_fs" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.proj_under_prep" label="% Project under preparation" name="project_status.status_high_level.proj_under_prep" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Status (detailed)</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_detailed.implemented" label="% Implemented" name="project_status.status_detailed.implemented" disabled={true}/>
                                </Col>
                                <Col lg={12}>
                                    <div style={{borderBottom: "3px solid #004494"}}>
                                        <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>On-going project (funding secured)</Form.Label>
                                    </div>
                                    <Row style={{paddingTop: "15px"}}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.workCur" label="% Works currently under execution" name="project_status.status_detailed.ongoing_proj_fs.workCur" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.tenderWork" label="% Tender for works/design-build on-going" name="project_status.status_detailed.ongoing_proj_fs.tenderWork" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.designTender" label="% Design/Tender Dossier for DB under preparation" name="project_status.status_detailed.ongoing_proj_fs.designTender" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.tenderOngoing" label="% Tender for design on-going or about to be start" name="project_status.status_detailed.ongoing_proj_fs.tenderOngoing" disabled={true}/>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12}>
                                    <div style={{borderBottom: "3px solid #004494"}}>
                                        <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Mature project (feasibility study ready, funding secured)</Form.Label>
                                    </div>
                                    <Row style={{paddingTop: "15px"}}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finOngoing" label="% Procedures on-going" name="project_status.status_detailed.mature_proj_fs.finOngoing" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finProceduresNotyetStarted" label="% Procedures not-yet-started" name="project_status.status_detailed.mature_proj_fs.finProceduresNotyetStarted" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finSourceNotInd" label="% Financing source not identified" name="project_status.status_detailed.mature_proj_fs.finSourceNotInd" disabled={true}/>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12}>
                                    <div style={{borderBottom: "3px solid #004494"}}>
                                        <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Project under preparation</Form.Label>
                                    </div>
                                    <Row style={{paddingTop: "15px"}}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.feasOnGoing" label="% Feasibility study on-going" name="project_status.status_detailed.proj_under_prep.feasOnGoing" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.feasUnderTen" label="% Feasibility study under tendering" name="project_status.status_detailed.proj_under_prep.feasUnderTen" disabled={true}/>
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.financing" label="% Procurement not yet started" name="project_status.status_detailed.proj_under_prep.financing" disabled={true}/>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_funding" title="Project Funding" className={style.tabHeight} style={{height: "66vh"}}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Funding Sources</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_nat_budg" label="% National Budget" name="project_funding.funding_source.proj_fund_nat_budg" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_wb" label="% WB" name="project_funding.funding_source.proj_fund_wb" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_ebrd" label="% EBRD" name="project_funding.funding_source.proj_fund_ebrd" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_eib" label="% EIB" name="project_funding.funding_source.proj_fund_eib" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.other_ifi" label="% Other IFI" name="project_funding.funding_source.other_ifi" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.concessions" label="% Concessions" name="project_funding.funding_source.concessions" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.eu_fund" label="% EU Fund" name="project_funding.funding_source.eu_fund" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.other_fund" label="% Other funding source" name="project_funding.funding_source.other_fund" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="project_funding.capex" label="CAPEX" name="project_funding.capex" disabled={true}/>
                        </Col>
                        {/* <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("project_funding.capex", "capex")}/>
                        </Col> */}
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="performance_indicators" title="Performance Indicators" className={style.tabHeight} style={{height: "66vh"}}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.const_period" label="Construction period (actual/forecasted)" name="performance_indicators.const_period" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.capex" label="CAPEX (actual/forecasted)" name="performance_indicators.capex" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.opex" label="OPEX (actual/forecasted)" name="performance_indicators.opex" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.maint_cost" label="Maintenance Cost (actual/forecasted)" name="performance_indicators.maint_cost" disabled={true}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.interest_during_const" label="% Interest During Construction" name="performance_indicators.interest_during_const" disabled={true}/>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="performance_indicators.ebitda" label="EBITDA (last year)" name="performance_indicators.ebitda" disabled={true}/>
                        </Col>
                        <Col lg={1}>
                            <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{fontSize: "12px", padding: "0.7rem 1rem"}} icon={BsArrowClockwise} onclick={() => showModalCalRange("performance_indicators.ebitda", "ebitda")}/>
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="performance_indicators.revenue" label="Revenue (actual/forecasted) (if fare/toll collected)" name="performance_indicators.revenue" disabled={true}/>
                        </Col>
                        <Col lg={12}>
                            <div style={{borderBottom: "3px solid #004494"}}>
                                <Form.Label style={{color: '#004494', fontSize: "16px", fontWeight: "bold"}}>Traffic</Form.Label>
                            </div>
                            <Row style={{paddingTop: "15px"}}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performance_indicators.traffic_dev.train_traffic" label="Train traffic deviation" name="performance_indicators.traffic_dev.train_traffic" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performance_indicators.traffic_dev.pass_traffic" label="Passenger cars Traffic Deviation" name="performance_indicators.traffic_dev.pass_traffic" disabled={true}/>
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="performance_indicators.traffic_dev.freight_tn" label="Freight (tn) deviation" name="performance_indicators.traffic_dev.freight_tn" disabled={true}/>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
        </Tabs>
    )
}

export default FREIGHT_IMP_PM_KPI;